export default "__VITE_ASSET__BnvVVbil__"